import {
  GET_DEVICES_FAIL,
  GET_DEVICES_SUCCESS,
  ADD_DEVICE_SUCCESS,
  ADD_DEVICE_FAIL,
  UPDATE_DEVICE_SUCCESS,
  UPDATE_DEVICE_FAIL,
  DELETE_DEVICE_SUCCESS,
  DELETE_DEVICE_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  devices: [],
}

const Devices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEVICES_SUCCESS:
      return {
        ...state,
        devices: action.payload,
      }

    case GET_DEVICES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_DEVICE_SUCCESS:
      return {
        ...state,
        devices: [...state.devices, action.payload],
      }

    case ADD_DEVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_DEVICE_SUCCESS:
      return {
        ...state,
        devices: state.devices.map(device =>
          device._id === action.payload._id.toString()
            ? { device, ...action.payload }
            : device
        ),
      }

    case UPDATE_DEVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_DEVICE_SUCCESS:
      return {
        ...state,
        devices: state.devices.filter(
          device => device._id.toString() !== action.payload._id.toString()
        ),
      }

    case DELETE_DEVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Devices
